/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ReconciliationInputs */

const vi_nav_reconciliation = /** @type {(inputs: Nav_ReconciliationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đối soát CK`)
};

/**

* @param {Nav_ReconciliationInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_reconciliation = /** @type {((inputs?: Nav_ReconciliationInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ReconciliationInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_reconciliation(inputs)
});